import { ITransaction } from '.';

export const initialFormValues: ITransaction = {
  company: '',
  transactionType: '',
  reference: '',
  number: '',
  date: '',
  description: '',
  note: '',
  TransactionDocuments: [],
};

export const accountCurrencyInitialValues = {
  initialError: {
    accountName: '',
    description: '',
    accountDebit: '',
    accountCredit: '',
    systemDebit: '',
    systemCredit: '',
    systemSecondaryDebit: '',
    systemSecondaryCredit: '',
  },
  initialTouched: {
    accountName: false,
    description: false,
    accountDebit: false,
    accountCredit: false,
    systemDebit: false,
    systemCredit: false,
    systemSecondaryDebit: false,
    systemSecondaryCredit: false,
  },
};
